// extracted by mini-css-extract-plugin
export var active = "_35-7";
export var backButton = "_35-6";
export var clone = "_35-c";
export var collapseBar = "_35-h";
export var collapseMode = "_35-j";
export var collapsed = "_35-l";
export var dragHandle = "_35-a";
export var dropdownIcon = "_35-e";
export var expanding = "_35-k";
export var hidden = "_35-r";
export var iconContainer = "_35-o";
export var iconSwapper = "_35-q";
export var navItem = "_35-4";
export var navItemIcon = "_35-d";
export var navProfile = "_35-5";
export var notificationCountBadge = "_35-g";
export var notificationDot = "_35-p";
export var optionsContainer = "_35-f";
export var primaryNav = "_35-0";
export var primaryTab = "_35-m";
export var secondaryNav = "_35-1";
export var selected = "_35-n";
export var settingsNav = "_35-2";
export var settingsNavItems = "_35-3";
export var show = "_35-b";
export var sideNav = "_35-i";
export var teamItem = "_35-8";
export var userProfileItem = "_35-9";